module.exports = __webpack_public_path__ + "static/img/10.0ae46b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/10.jpg
// module id = W5da
// module chunks = 0